import { apiClient } from "~/lib/client";
import { handleApiError, handleResponse } from "~/utils/response";
import { queryOptions } from "@tanstack/react-query";
import { BookingRulesExtraResponse, BookingRulesResponse, ScheduleResponse } from "../types";
import { settingsKeys } from "./keys";

export const scheduleQueryOptions = () => {
    return queryOptions({
        queryKey: settingsKeys.schedules(),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient('/admin/schedules');
                const result = await handleResponse<ScheduleResponse>(response);

                if (!result.success) {
                    throw new Error(result.error);
                }

                return result.data;
            } catch (error) {
                handleApiError(error);
                throw error;
            }
        }
    });
};

export const bookingRulesQueryOptions = () => {
    return queryOptions({
        queryKey: settingsKeys.bookingRules(),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient('/admin/booking-rules');
                const result = await handleResponse<BookingRulesResponse>(response);

                if (!result.success) {
                    throw new Error(result.error);
                }
                return result.data;
            } catch (error) {
                handleApiError(error);
                throw error;
            }
        }
    });
};

export const bookingRulesExtraQueryOptions = () => {
    return queryOptions({
        queryKey: settingsKeys.bookingRulesExtra(),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient('/admin/booking-rules-advanced');
                const result = await handleResponse<BookingRulesExtraResponse>(response);

                if (!result.success) {
                    throw new Error(result.error);
                }

                return result.data;
            } catch (error) {
                handleApiError(error);
                throw error;
            }
        }
    });
};